import React from 'react'
import { connect } from 'react-redux';
import styles from "./IndicatorsDashbordOrg.module.css";

import {getTrainingQuality} from '../../../../actions/report'

import BtnBack from '../../helper/btnBack/BtnBack';
import GetHeader from '../../helper/getHeader/GetHeader';
import back1 from '../../../../assets/dashboard/background_1.png'
import circle from '../../../../assets/dashboard/circle.png'
import { useEffect } from 'react';

const IndicatorsDashbordOrg = ({
  getTrainingQuality,
  training_quality = []
}) => {

  useEffect(() => {
    getTrainingQuality()
  }, [])

const colors = ['red', 'green', 'blue', 'blueviolet', 'yellow'];

const getSum = (data) => data?.reduce((accumulator, currentValue) => accumulator + currentValue.count, 0); //Получаем сумму баллов
const getPers = (data, sum) => data?.map(el=> `${el.count / (sum / 100)}` ).sort( (a, b) => a - b); //Получаем отсортированный список баллов в процентах

  const getValues = (data) => {
    const sum = getSum(data)
    const toPersList = getPers(data, sum);

    let start = toPersList && [`${colors[0]} 0% ${toPersList[0]}%`]; //Стартовый массив
    let persSumm = toPersList && +toPersList[0]; //Сумма процентов
    const x = toPersList?.map((el, inx) => {
      
      if (inx > 0 && toPersList.length - 1 != inx) {
        persSumm = persSumm + +el;     
        start.push(`${colors[inx]} ${toPersList[inx - 1]}% ${persSumm}%`)
      }

      if (toPersList.length - 1 == inx) {
        if (toPersList.length == 2) {
        } 
        start.push(`${colors[inx]} ${persSumm}%`)
      }
      
    })

    return start;
  }
  
  const getConicGradient = (data) => {
    const x = `conic-gradient(${getValues(data)?.map(el => `${el}`)})`; //Формируем сonic-пradient css-стиль 
    return x;
  }

  return (
    <div className={styles.wrapper}>
      <img src={back1} className={styles.bg}/>
      <GetHeader title={<>Показатели организации образовательной деятельности и качества подготовки военных кадров</>}/>

      <div className={styles.wrapperInner}>
        <div>
          <div 
          className={styles.speciality}>
            <div className={styles.speciality_title}>В вузах минобороны России ведется подготовка по 397 военным специальностям</div>
              
            <div className={styles.chartContainer}>
              <div 
                className={styles.pieChart}
                style={{
                  backgroundImage: getConicGradient(training_quality?.speciality),
                  width: '300px',
                  height: '300px'
                }}
                ></div>

              <div className={styles.pieLegenda}>
                {
                  training_quality?.speciality?.sort( (a, b) => a.count - b.count).map((el, inx) => {
                    const index = training_quality?.speciality?.length - 1 - inx;
                    return (
                      <div className={styles.entry}>
                        <div className={styles.entryColor} style={{background: `${colors[index]}`}}></div>
                        <div className={styles.entryText}
                        style={{width: '400px'}}
                        >{training_quality?.speciality[index]?.name} <span>{training_quality?.speciality[index].count}</span></div>
                      </div>
                    )
                  }   
                  )
                }
              </div>
            </div>
            </div>
          <div className={styles.fgos}>
            <div className={styles.fgos_title}>всего реализуется 109 федеральных государственных образовательных стандартов</div>
              {training_quality?.fgos && 
              <div className={styles.blocks}>
                <div className={styles.chartContainer}>
                  <div 
                    className={styles.pieChart}
                    style={{
                      backgroundImage: getConicGradient(training_quality?.fgos[0]?.areas_of_training),
                      width: '180px',
                      height: '180px'
                    }}
                    ></div>

                    <div className={styles.pieLegenda}>
                      {
                        training_quality?.fgos[0]?.areas_of_training?.sort( (a, b) => a.count - b.count).map((el, inx) => {
                          const index = training_quality?.fgos[0]?.areas_of_training?.length - 1 - inx;
                          return (
                            <div className={styles.entry}>
                              <div className={styles.entryColor} style={{background: `${colors[index]}`}}></div>
                              <div className={styles.entryText}>{training_quality?.fgos[0]?.areas_of_training[index]?.name} <span>{training_quality?.fgos[0]?.areas_of_training[index].count}</span></div>
                            </div>
                          )
                        }   
                        )
                      }

                    </div>
                </div>

                <div className={styles.chartContainer}>
                  <div 
                    className={styles.pieChart}
                    style={{
                      backgroundImage: getConicGradient(training_quality?.fgos[0]?.created_by),
                      width: '180px',
                      height: '180px'
                    }}
                    ></div>

                    <div className={styles.pieLegenda}>
                      {
                        training_quality?.fgos[0]?.created_by?.sort( (a, b) => a.count - b.count).map((el, inx) => {
                          const index = training_quality?.fgos[0]?.created_by?.length - 1 - inx;
                          return (
                            <div className={styles.entry}>
                              <div className={styles.entryColor} style={{background: `${colors[index]}`}}></div>
                              <div className={styles.entryText}>{training_quality?.fgos[0]?.created_by[index]?.name} <span>{training_quality?.fgos[0]?.created_by[index].count}</span></div>
                            </div>
                          )
                        }   
                        )
                      }

                    </div>
                </div>
              </div>
              }
          </div>
        </div>
        <div>
          <div 
          className={styles.honors_degree}>
            <div className={styles.honors_degree_title}>доля слушателей и курсантов, завершивших обучение с дипломом с отличием</div>
              <div className={styles.chartCylinderContainer}>
              {
                training_quality?.honors_degree?.map((el, inx) =>
                  <div className={styles[`honors_degreeBlock_${inx}`]}>
                    <div className={styles.chartCylinder}
                    style={{height: `${230 / training_quality?.honors_degree?.map(el => el.perc).sort((a, b) => b - a)[0] * el.perc}px`}}>
                      <div className={styles.perc}>{el.perc}</div>
                    </div>
                    <span>{el.name}</span>
                  </div>
                )
              }
              </div>
            </div>
          <div className={styles.avg_mark}>
            <div className={styles.avg_mark_title}>средний балл сдачи государственных аттестационнных испытаний</div>
              {training_quality?.avg_mark && 
              <div className={styles.blocks}>
                <div className={styles.avg_markChartCylinderContainer}>
              {
                training_quality?.avg_mark?.map((el, inx) =>
                  <div className={styles[`honors_degreeBlock_${inx}`]}>
                    <div className={styles.chartCylinder}
                    style={{height: `${130 / training_quality?.avg_mark?.map(el => el.score).sort((a, b) => b - a)[0] * el.score}px`}}>
                      <div className={styles.perc}>{el.score}</div>
                    </div>
                    <span style={{height: '80px'}}>{el.name}</span>
                  </div>
                )
              }
              </div>
              </div>
              }
          </div>
        </div>
      </div>
      <BtnBack/>

    </div>
  )
}

const mapStateToProps = (state) => ({
  training_quality: state.report.training_quality
});
  
  export default connect(mapStateToProps, {
    getTrainingQuality 
  })(IndicatorsDashbordOrg);